<!--Form-->
<!-- Always do manual prettify -->
<form>
	<div class="card">
		<div class="card-body">
			<h5 class="card-title">{{title}}</h5>
			<table class="table table-striped table-bordered">
				<thead>
					<th *ngFor="let column of model">{{column.label}}</th>
					<th>Actions</th>
				</thead>
				<tbody>
					<ng-container *ngFor="let data of tableData; index as outerIndex">
						<tr>
							<td *ngFor="let column of model; index as innerIndex">
								<input
									class="form-control"
									name="innerIndex"
									[type]="getType(valueAtPath(data, column.id))"
									[value]="valueAtPath(data, column.id)"
									(input)="updateDataObject(data, $event, column.id)"
									[disabled]="!data.isEditable">
							</td>
							<td>
								<a href="javascript:;"
									data-toggle="tooltip"
									data-placement="top"
									title="Edit"
									(click)="data.isEditable = !data.isEditable">
									<i class='bx bxs-edit-alt'></i>
								</a> &nbsp;
								<a href="javascript:;"
									data-toggle="tooltip"
									data-placement="top"
									title="Remove"
									(click)="removeData(outerIndex)">
									<i class='bx bx-trash' ></i>
								</a>
							</td>
						</tr>
					</ng-container>
				</tbody>

			</table>
		</div>
		<div class="card-footer">
			<ng-container *ngIf="showProgress">
				<h5>Progress</h5>
				<div class="progress mt-3 mb-4">
					<div class="progress-bar progress-bar-striped active" role="progressbar"
					aria-valuenow="40" aria-valuemin="0" aria-valuemax="100" [ngStyle]="{ 'width': progressPercent+'%' }">
					  {{progressPercent}}%
					</div>
				</div>
			</ng-container>
			<am-button [text]="submitButtonText" (click)="onSubmit()" [isLoading]="isButtonDisabled"></am-button>
			<a href="javascript:;" (click)="cancel()" class="btn btn-light ml-3">{{cancelButtonText}}</a>
		</div>
	</div>
</form>